let memoizedColumns = []
const WorkflowActionColumns = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'action',
            header: 'Action',
        }
    ]
    return memoizedColumns
}

export default WorkflowActionColumns;